import { motion } from "framer-motion";
import { Zap, Truck, Sparkles, Timer } from "lucide-react";

export default function HeroBento({ onShopNow, onSeePromo, onSeePrinting, onSeeSembako, onSeeFasnet, onSeeFrozen }) {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-8 pt-4 sm:pt-6 pb-3 sm:pb-4">
      <div>
        {/* Big feature card */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="relative overflow-hidden rounded-3xl bg-emerald-900 text-white p-5 sm:p-6 md:p-8 min-h-[150px] md:min-h-[190px]"
        >
          <img
            src="https://customer-assets-7cd3h4nn.emergentagent.net/job_fasmart-online/artifacts/l7e1tpni_ChatGPT%20Image%2030%20Agu%202026%2C%2001.22.19.webp"
            alt="Keluarga belanja di FASMART"
            data-testid="hero-bg-image"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-emerald-950/90 via-emerald-950/55 to-emerald-900/15" />
          <div className="relative">
            <span className="tag-pill bg-amber-400 text-emerald-950">
              <Sparkles className="w-3 h-3" /> Minimarket Online
            </span>
            <div className="mt-3 sm:mt-5 text-xs font-mono uppercase tracking-[0.2em] text-amber-300 font-semibold">FASMART</div>
            <h1 className="mt-1.5 sm:mt-2 font-display font-black text-[22px] sm:text-[38px] lg:text-[50px] leading-[1.08] tracking-tight">
              Belanja Dekat, <span className="text-amber-300">Lebih Hemat.</span>
            </h1>
            <div className="mt-4 sm:mt-5 flex flex-wrap gap-2.5 sm:gap-3">
              <button
                data-testid="hero-shop-now-btn"
                onClick={onShopNow}
                className="px-6 py-3 rounded-full bg-amber-400 text-emerald-950 font-bold hover:bg-amber-300 transition shadow-lg shadow-amber-400/30 flex items-center gap-2"
              >
                <Zap className="w-4 h-4" /> Belanja Sekarang
              </button>
              <button
                data-testid="hero-see-promo-btn"
                onClick={onSeePromo}
                className="px-6 py-3 rounded-full bg-white/10 border border-white/20 text-white font-semibold hover:bg-white/20 transition"
              >
                Lihat Promo Hari Ini
              </button>
            </div>
            <div className="mt-5 sm:mt-8 flex items-center gap-4 sm:gap-6 text-[10px] sm:text-xs font-mono uppercase tracking-widest text-emerald-100/80">
              <span className="flex items-center gap-2"><Truck className="w-4 h-4" /> Antar 30–60 Menit</span>
              <span className="flex items-center gap-2"><Timer className="w-4 h-4" /> Buka 06.00–22.00</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
